import { createReducer, on } from '@ngrx/store';
import { ActiveMaintenanceNoticeDTO } from '@chicilon/angular-user-service';
import {
  dismissMaintenanceNotice,
  loadMaintenanceNoticeSuccess,
  setIsSidebar,
  setMaintenanceNoticeDismissedState
} from './system.actions';

export interface SystemState {
  isSidebar: boolean;
  maintenanceNotice: ActiveMaintenanceNoticeDTO | null;
  isMaintenanceNoticeDismissed: boolean;
}

const initialState: SystemState = {
  isSidebar: false,
  maintenanceNotice: null,
  isMaintenanceNoticeDismissed: false
};

export const systemReducer = createReducer(
  initialState,
  on(setIsSidebar, (state, { isSidebar }) => ({
    ...state,
    isSidebar: isSidebar
  })),
  on(loadMaintenanceNoticeSuccess, (state, { notice }) => ({
    ...state,
    maintenanceNotice: notice
  })),
  on(dismissMaintenanceNotice, state => ({
    ...state,
    isMaintenanceNoticeDismissed: true
  })),
  on(setMaintenanceNoticeDismissedState, (state, { dismissed }) => ({
    ...state,
    isMaintenanceNoticeDismissed: dismissed
  }))
);
